import { Box } from '@chakra-ui/react';
import { CheckListItem } from './check-list-item';
import Link from 'next/link';
import * as analytics from 'utils/analytics';
import { useTweetContext } from 'context/tweetContext';
import { CheckListProps } from 'types/gamification';

export const CheckList = ({ items, linkedMap }: CheckListProps) => {
  const tweetContext: any = useTweetContext();
  return (
    <>
      {items.map((item) => {
        if (linkedMap[item.name] === 'newPost') {
          return (
            <Box
              key={item.title}
              cursor='pointer'
              onClick={() => {
                analytics.log('gamification_link_click', {
                  gamification_item: item.name,
                });
                tweetContext.newTweet({
                  text: '',
                });
                tweetContext.open();
              }}
            >
              <CheckListItem {...item} hasHoverEffect />
            </Box>
          );
        }
        if (linkedMap[item.name]) {
          return (
            <Link
              key={item.title}
              href={linkedMap[item.name]}
              onClick={() => {
                analytics.log('gamification_link_click', {
                  gamification_item: item.name,
                });
              }}
            >
              <CheckListItem {...item} hasHoverEffect />
            </Link>
          );
        }
        return (
          <CheckListItem key={item.title} {...item} hasHoverEffect={false} />
        );
      })}
    </>
  );
};
